var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-bar-item',{attrs:{"icon":_vm.icon,"title":_vm.title,"toptitle":"Konnektor"}})
}
var staticRenderFns = []

export { render, staticRenderFns }